(function () {
  'use strict';

  // Shared behavior for converse.com's own size-guide markup (raw HTML injected
  // wherever a Fit Standard's Size chart Page is rendered): the PDP's fit-standard
  // drawer (snippets/product-info.liquid) AND the standalone Size Chart page
  // template (sections/size-chart-page.liquid) both load this file so the toggle
  // and hover behavior is identical in both places, with no duplicated JS.
  // Delegated on document rather than bound per-element at init, since the drawer's
  // copy of this markup gets wholesale replaced on every product:rerender.

  if (!window.__sizeChartToggleBound) {
    window.__sizeChartToggleBound = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.size-guide__size-chart-toggle-btn');
      if (!btn) return;

      var config;
      try {
        config = JSON.parse(btn.getAttribute('data-size-chart-toggle') || '{}');
      } catch (err) {
        return;
      }
      if (!config.tableMatch) return;

      var targetTable = document.querySelector('[data-size-chart-table="' + config.tableMatch + '"]');
      // No matching table for this unit yet (e.g. a cm table hasn't been added to
      // the page) -- leave whatever is currently shown as-is rather than hiding it.
      if (!targetTable) return;

      document.querySelectorAll('[data-size-chart-table]').forEach(function (table) {
        table.classList.toggle('hidden', table !== targetTable);
      });

      var toggleGroup = btn.parentElement;
      if (toggleGroup) {
        toggleGroup.querySelectorAll('.size-guide__size-chart-toggle-btn').forEach(function (b) {
          b.classList.toggle('size-guide__size-chart-toggle-btn--active', b === btn);
        });
      }
    });
  }

  // Column hover-highlight, mirroring converse.com's own size-guide-fancy-con.js:
  // hovering a cell highlights its whole column (all rows + header) plus any
  // earlier columns in that same row.
  if (!window.__sizeChartHoverBound) {
    window.__sizeChartHoverBound = true;

    document.addEventListener('mouseover', function (event) {
      var cell = event.target.closest('.size-guide__size-chart-body td');
      if (!cell) return;

      var table = cell.closest('table');
      if (!table) return;

      cell.classList.add('size-guide__size-chart--hover');

      var colIndex = Array.prototype.indexOf.call(cell.parentNode.children, cell);

      // Scoped to the same table as the hovered cell -- both cm/in tables coexist
      // in the DOM at once with one hidden, so this avoids touching the hidden one.
      table.querySelectorAll('.size-guide__size-chart-body tr').forEach(function (row) {
        var sibling = row.children[colIndex];
        if (sibling) sibling.classList.add('size-guide__size-chart--sibling-hover');
      });

      Array.prototype.forEach.call(cell.parentNode.children, function (sibling, i) {
        if (i < colIndex) sibling.classList.add('size-guide__size-chart--sibling-hover');
      });

      var header = table.querySelector('.size-guide__size-chart-header tr');
      if (header && header.children[colIndex]) {
        header.children[colIndex].classList.add('size-guide__size-chart--sibling-hover');
      }
    });

    document.addEventListener('mouseout', function (event) {
      var cell = event.target.closest('.size-guide__size-chart-body td');
      if (!cell) return;

      cell.classList.remove('size-guide__size-chart--hover');
      document.querySelectorAll('.size-guide__size-chart--sibling-hover').forEach(function (el) {
        el.classList.remove('size-guide__size-chart--sibling-hover');
      });
    });
  }
})();
